import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function TabelaRodape({
  total = 0,
  pagina = 1,
  itensPorPagina = 10,
  onPaginaChange = () => {},
}) {
  const paginas = Math.max(1, Math.ceil(total / itensPorPagina));

  return (
    <div
      className="flex items-center justify-center px-4 py-2 border-t"
      style={{
        backgroundColor: "#D1EBFA",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "16px",
        color: "#454545",
      }}
    >
      <div className="flex items-center gap-2">
        {/* Botões navegação */}
        <button
          className="p-1 disabled:opacity-40"
          onClick={() => onPaginaChange(1)}
          disabled={pagina === 1}
        >
          <ChevronsLeft size={18} />
        </button>

        <button
          className="p-1 disabled:opacity-40"
          onClick={() => onPaginaChange(pagina - 1)}
          disabled={pagina === 1}
        >
          <ChevronLeft size={18} />
        </button>

        {/* Página atual com animação */}
        <AnimatePresence mode="wait">
          <motion.span
            key={pagina} // 🔹 força recriar quando muda a página
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.25 }}
            className="px-3 py-1 bg-[#004466] text-white text-sm rounded inline-block min-w-[60px] text-center"
          >
            {pagina} / {paginas}
          </motion.span>
        </AnimatePresence>

        <button
          className="p-1 disabled:opacity-40"
          onClick={() => onPaginaChange(pagina + 1)}
          disabled={pagina === paginas}
        >
          <ChevronRight size={18} />
        </button>

        <button
          className="p-1 disabled:opacity-40"
          onClick={() => onPaginaChange(paginas)}
          disabled={pagina === paginas}
        >
          <ChevronsRight size={18} />
        </button>
      </div>
    </div>
  );
}
